import { PlaceholdersId, TFComponent } from '@types';
import { AccountSelectedPlaceholder } from './accountSelected';

export const accountSelected: TFComponent = {
	component: AccountSelectedPlaceholder,
	id: PlaceholdersId.accountSelected,
	name: 'AccountSelected',
};
